import { AfterViewInit, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { RequestModel } from 'src/app/models/request/request-model';
import { SemControlComponent } from '../../../sem-control/sem-control.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'sem-graph-pie',
  templateUrl: './sem-line-graph.component.html',
  styleUrls: ['./sem-line-graph.component.css']
})
export class SemLineGraphComponent extends SemControlComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild("chartContainer", { read: ElementRef, static: true }) element: ElementRef;

  @Input() settings: any;
  @Input() valuesName: string = "...";

  multi: any[] = [
    {
      "name": this.valuesName,
      "series": [/*
        {
          "name": "2017",
          "value": 30
        },
        {
          "name": "2018",
          "value": 40
        },
        {
          "name": "2019",
          "value": 100
        },
        {
          "name": "2020",
          "value": 60
        },
        {
          "name": "2021",
          "value": 220
        }
      */]
    }
  ];

  view: any[] = [400, 250];

  // options
  legend: boolean = false;
  showLabels: boolean = false;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  showYAxisLabel: boolean = false;
  showXAxisLabel: boolean = false;
  xAxisLabel: string = 'Year';
  yAxisLabel: string = 'Population';
  timeline: boolean = true;
  loading: boolean = true;
  hasData: boolean = false;

  results: any = [
    {
      "name": "",
      "series": [
      ]
    }
  ];

  colorScheme = {
    domain: ['#cc922f', '#447695']
  };
  private filterSub: Subscription;

  super() {
    //Object.assign(this, { this.multi });
  }

  ngAfterViewInit(): void {
  }

  ngOnInit() {
    this.setViewSize();

    if (typeof this.settings["GraphValueTitle"] != "undefined" && this.settings["GraphValueTitle"]) {
      this.results[0].name = this.settings["GraphValueTitle"];
    }

    this.loadData();

    this.filterSub = this.dfms.bindValueChange.subscribe((event: any) => {
      if (event?.type === 'statistics-filter-refresh') {
        this.loadData();
      }
    });
  }

  ngOnDestroy() {
    if (this.filterSub) {
      this.filterSub.unsubscribe();
    }
  }

  private resolveBindingValue(bindingPath: string): any {
    const directPath = bindingPath as string;
    const normalizedPath = directPath.startsWith("model.") ? directPath.replace(/^model\./, "") : directPath;
    return this.dfms?.getValue(this.model, normalizedPath);
  }

  private buildUrlWithParams(baseUrl: string): string {
    if (!this.settings?.QueryParameters) {
      return baseUrl;
    }

    const urlParts = baseUrl.split('?');
    const path = urlParts[0];
    const existingParams = new URLSearchParams(urlParts[1] || '');

    for (const [paramName, bindingPath] of Object.entries(this.settings.QueryParameters)) {
      const value = this.resolveBindingValue(bindingPath as string);
      if (value != null && typeof value !== 'undefined' && value !== '') {
        let formatted = value;
        try {
          if ((value as any).toISOString) {
            formatted = (value as any).toISOString();
          }
        } catch (e) { }
        existingParams.set(paramName, formatted as string);
      } else {
        existingParams.delete(paramName);
      }
    }

    const qs = existingParams.toString();
    return qs ? `${path}?${qs}` : path;
  }

  private loadData() {
    this.loading = true;
    const url = this.buildUrlWithParams(this.settings["Endpoint"]);

    if (typeof this.settings["ApiMethodType"] == "undefined" || this.settings["ApiMethodType"] == 0 || this.settings["ApiMethodType"] == 2) {
      let model = new RequestModel();
      model.data = {};
      model.url = url;
      this.restProviderService.getDataPOST(model).subscribe(data => {
        const series = Array.isArray(data) ? data : [];
        this.results[0].series = series;
        this.hasData = series.length > 0;
        this.multi = this.hasData ? [...this.results] : [];
        this.loading = false;
      }, error => {
        console.error("Graph load error:", error);
        this.hasData = false;
        this.multi = [];
        this.loading = false;
      });
    } else {
      this.restProviderService.getDataGET(url).subscribe((data: any) => {
        const parsedData = JSON.parse(data);
        const series = Array.isArray(parsedData) ? parsedData : [];
        this.results[0].series = series;
        this.hasData = series.length > 0;
        this.multi = this.hasData ? [...this.results] : [];
        this.loading = false;
      }, error => {
        console.error("Graph load error:", error);
        this.hasData = false;
        this.multi = [];
        this.loading = false;
      });
    }
  }

  /*onResize(event) {
    this.setViewSize();
  }*/

  setViewSize() {
    /*this.view[0] = this.control.nativeElement.parentElement.clientWidth - 135;
    this.view[1] = this.control.nativeElement.parentElement.clientHeight - 165;*/
  }

  onSelect(data): void {
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data): void {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data): void {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }
}
